module.exports = __webpack_public_path__ + "static/media/product.4328070a.svg";